module.exports = __webpack_public_path__ + "img/di.4836f977.png";